// Minimal HTML escape for values interpolated into SweetAlert2's `html` field.
// SweetAlert2 doesn't sanitize the html input, so any unescaped user-controlled
// value would be an XSS vector.
export function escapeHtml(s: string | number | null | undefined): string {
  if (s == null) return "";
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}
